<div class="flexbox-parent" style="margin-top: 15vh;">
  <div class="main-wrapper" layout="row" layout-fill layout-align="center center">

    <mat-card class="box">
      <mat-card-header>
        <mat-card-title>Sign Up</mat-card-title>
      </mat-card-header>

      <form class="example-form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <mat-card-content>
          <mat-form-field class="example-full-width">
            <input matInput placeholder="Name" type="name" formControlName="name">
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <input matInput placeholder="Email" type="email" formControlName="email">
          </mat-form-field>

          <mat-form-field class="example-full-width">
            <input matInput placeholder="Password" type="password" formControlName="password">
          </mat-form-field>

        </mat-card-content>
        <button mat-stroked-button color="primary" class="btn-block" type="submit">
        Sign-up</button>
        <br><br>
        <a href="/login" style="float: right;">Have an Account?, Login</a>
        <br><br>
      </form>
      <button mat-stroked-button color="accent" class="btn-block" (click)="googleSignIn()">Continue with Google</button>
    </mat-card>

  </div>
</div>
